"use client";

import { MenuPaymentMethodsMethod, MenusOutput } from "@/interfaces/menus";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import {
  CreditCard,
  Banknote,
  Smartphone,
  DollarSign,
  Zap,
} from "lucide-react";

interface PaymentMethodsSettingsProps {
  menu: MenusOutput;
  onMenuChange: (menu: MenusOutput) => void;
}

const PAYMENT_METHODS = [
  {
    method: MenuPaymentMethodsMethod.CREDIT_CARD,
    label: "Cartão de Crédito",
    icon: CreditCard,
  },
  {
    method: MenuPaymentMethodsMethod.DEBIT_CARD,
    label: "Cartão de Débito",
    icon: CreditCard,
  },
  {
    method: MenuPaymentMethodsMethod.PIX,
    label: "PIX",
    icon: Smartphone,
  },
  {
    method: MenuPaymentMethodsMethod.CASH,
    label: "Dinheiro",
    icon: Banknote,
  },
  {
    method: MenuPaymentMethodsMethod.ZELLE,
    label: "Zelle",
    icon: Zap,
  },
];

export function PaymentMethodsSettings({
  menu,
  onMenuChange,
}: PaymentMethodsSettingsProps) {
  const togglePaymentMethod = (method: MenuPaymentMethodsMethod) => {
    const currentMethods = [...menu.allowedPaymentMethods];
    const isSelected = currentMethods.includes(method);

    if (isSelected) {
      onMenuChange({
        ...menu,
        allowedPaymentMethods: currentMethods.filter((m) => m !== method),
      });
    } else {
      onMenuChange({
        ...menu,
        allowedPaymentMethods: [...currentMethods, method],
      });
    }
  };

  return (
    <div>
      <h4 className="text-sm font-medium mb-3 flex items-center">
        <DollarSign className="h-4 w-4 mr-2" />
        Métodos de Pagamento Aceitos
      </h4>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {PAYMENT_METHODS.map(({ method, label, icon: Icon }) => (
          <div key={method} className="flex items-center space-x-2">
            <Checkbox
              id={`payment-${method}`}
              checked={menu.allowedPaymentMethods.includes(method)}
              onCheckedChange={() => togglePaymentMethod(method)}
            />
            <Label
              htmlFor={`payment-${method}`}
              className="text-sm font-normal cursor-pointer flex items-center"
            >
              <Icon className="h-4 w-4 mr-1" />
              {label}
            </Label>
          </div>
        ))}
      </div>
    </div>
  );
}
